const viewportSmall = 400;
const viewportLarge = 800;
const viewportMedium = 576;
const viewportXLarge = 1024;

function onBreakpoint(breakpoint, callback) {
    let mql;
    if (window.matchMedia) {
        const breakpoints = {
            sm: viewportSmall,
            md: viewportMedium,
            lg: viewportLarge,
            xl: viewportXLarge,
        };
        let minWidth = (typeof breakpoint === 'string' && breakpoints[breakpoint]) || breakpoint;
        if (typeof minWidth === 'string' && /^\d+(px)?$/.test(minWidth)) {
            minWidth = parseInt(minWidth);
        }
        if (typeof minWidth === 'number') {
            minWidth = (minWidth / 16) + 'em';
        }
        mql = window.matchMedia(`(min-width: ${minWidth})`);
        mql.addEventListener('change', onChange);
        callback(mql.matches);
    }
    function onChange(event) {
        callback(event.matches);
    }
    return () => {
        if (mql) {
            mql.removeEventListener('change', onChange);
            mql = undefined;
        }
    };
}

export { onBreakpoint as o };

//# sourceMappingURL=onBreakpoint-9722be65.js.map